<app-slide id="applicantSlide" [title]="leadText+'Applicant Details'" supportingText="Please tell us about yourself."
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'applicant'"
    [slideCompleted]="formState.progress.applicantComplete">
    <div *ngIf="loading">
        <app-spinner></app-spinner>
    </div>
    <div class="alert alert-danger" *ngIf="showError">
        There has been an error loading your applicant details.
    </div>

    <div id="error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it
            again.
        </p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title | titlecase}},
                    {{error.msg}}
                </a>
            </li>
        </ul>
    </div>
    <ng-container *ngIf="fields | async as fields">
        <div>
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
            <div class="section ng-empty" *ngIf="showSubmit">
                <div class="row">
                    <div class="col-sm-offset-8 col-sm-4">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="position:relative;"
                                (click)="onSubmit()" [disabled]="isDisabled">
                                <span>Save &amp; Continue Securely</span>
                                <app-spinner *ngIf="submitting" class="applicationSubmitSpinner"></app-spinner>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</app-slide>